import { inject, Injectable } from '@angular/core';
import type { IContentStore } from '@app/interface/content/content-store.interface';
import type Coupon from '@app/interface/coupon/coupon.interface';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import { AutoApplyCouponType } from '@app/interface/content/auto-apply-coupon-type.enum';

@Injectable({
  providedIn: 'root'
})
export class CouponCodeService {
  private readonly contentStore = inject<IContentStore>(angularjs.ContentStore);

  public getDisplayCouponCode(coupon: Coupon): string {
    if (coupon.autoApplyType === AutoApplyCouponType.FAMILY_DISCOUNT) {
      return this.contentStore.translate('FAMILYDISCOUNT_COUPON_NAME');
    }
    return coupon.couponCode;
  }

  public isPromotionalCoupon(coupon?: Coupon): boolean {
    return coupon?.autoApplyType === AutoApplyCouponType.FAMILY_DISCOUNT;
  }
}
